import type { SVGProps } from 'react';

import SparklesIcon from '@/assets/icons/SparklesIcon';
import { cn } from '@/lib/cn';

type Props = SVGProps<SVGSVGElement>;

const AIIcon = (props: Props) => {
  const { className, ...rest } = props;
  return <SparklesIcon {...rest} className={cn('text-green-700', className)} />;
};

export default AIIcon;
